// extracted by mini-css-extract-plugin
export var columnList = "_co-0";